import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './styles/globals.css';
// import './components/falconReact/helpers/initFA';
import App from './App';
import Main from './Main';
import { store } from './store';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { createTheme, ThemeProvider } from '@mui/material/styles'; // Legacy (deprecated) theme api
import { initializeSentry } from './sentry';

import { LicenseInfo } from '@mui/x-license-pro';
import { CloudProvider } from './components/v2/content/CloudProviderBar/CloudProviderContext';
import { ThemeProvider as NewThemeProvider } from './context/ThemeContext';

const MUI_LICENSE_KEY: string = import.meta.env.VITE_MUI_KEY || '';
LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);

// console.log(import.meta.env);

const theme = createTheme({});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: Infinity, // 10 minutes // changed to 30mins for onboarding case
      cacheTime: Infinity, // 15 minutes // changed to 30mins for onboarding case
      keepPreviousData: true,
      retryDelay: 10000,
      refetchOnWindowFocus: false,
    },
  },
});

// PERF: Defer Sentry initialization to after page load
// This removes ~1-1.5s of main-thread work from LCP critical path
if (typeof window !== 'undefined') {
  if (document.readyState === 'complete') {
    // Page already loaded
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => initializeSentry(), { timeout: 3000 });
    } else {
      setTimeout(initializeSentry, 2000);
    }
  } else {
    // Wait for page load, then defer further
    window.addEventListener('load', () => {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(() => initializeSentry(), { timeout: 3000 });
      } else {
        setTimeout(initializeSentry, 2000);
      }
    });
  }
}

if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.error = () => { };
  console.debug = () => { };
}

const container = document.getElementById('main')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <NewThemeProvider>
        <ThemeProvider theme={theme}>
          <Provider store={store as any}>
            <QueryClientProvider client={queryClient}>
              <Main>
                <CloudProvider>
                  <App />
                </CloudProvider>
              </Main>
              {/* <Toaster richColors /> */}
            </QueryClientProvider>

          </Provider>
        </ThemeProvider>
      </NewThemeProvider>
    </LocalizationProvider>
  </React.StrictMode>
);
